import { existsSync } from 'node:fs';
import { join } from 'node:path';
import { SETUP_FILE } from '../constants';

export const getSetupFile = () => {
  const isSrcExists = existsSync('./src');
  const first = `${isSrcExists ? './src/' : './'}${SETUP_FILE}`;
  const out = join(process.cwd(), first);

  return out;
};
